import { Route, Routes } from "react-router-dom";
import CustomSpin from "../../component/Spin/CustomSpin";
import { SpinProvider } from "../../component/Spin/spin.context";
import Login from "./auth/screen/Login";
import DocumentList from "./document/screen/DocumentList";
import DocumentDetail from "./document/screen/DocumentDetail";

const PublicRoutes = () => {
  return (
    <div>
      <div className="page-content">
        <div className="content-wrapper">
          <SpinProvider>
            <CustomSpin>
              <Routes>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/category/:categoryUuid" element={<DocumentList />}></Route>
                <Route path="/view/:uuid" element={<DocumentDetail />}></Route>
                <Route path="/:categoryUuid" element={<DocumentList />}></Route>
              </Routes>
            </CustomSpin>
          </SpinProvider>
        </div>
      </div>
    </div>
  );
};

export default PublicRoutes;
